import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

export interface StartQuizResponse {
  success: boolean;
  message: string;
  data?: {
    startTime: string;
    endTime: string;
    timeRemaining: number;
  };
}

/**
 * Aktivira kviz ako je kod validan
 * @param kod - Admin kod iz URL-a
 * @returns StartQuizResponse objekat
 */
const startQuizAPI = async (kod: string): Promise<StartQuizResponse> => {
  try {
    const config: AxiosRequestConfig = {
      method: "POST",
      // Lokalno (development)
      // url: `http://localhost:6002/api/ultra/politehnika/start-quiz`,
      
      // Produkcija
      url: `https://politehnika-back.firebird.rs/api/ultra/politehnika/start-quiz`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        kod: kod.toUpperCase(),
      },
    };

    const response: AxiosResponse = await axios(config);
    
    console.log("✅ Kviz aktiviran - ceo response:", response.data);
    
    // Backend vraća CommonResponse strukturu:
    // { code, message, description, data: { success, data: { startTime, endTime, timeRemaining } } }
    
    const backendData = response.data.data; // Ovo je { success: true, data: {...} }
    
    return {
      success: backendData.success,
      message: response.data.description || response.data.message,
      data: backendData.data, // Ovo je { startTime, endTime, timeRemaining }
    };
  } catch (error: any) {
    console.error("❌ Greška pri aktivaciji kviza:", error);
    return {
      success: false,
      message: error.response?.data?.message || "Greška pri aktivaciji kviza",
    };
  }
};

export default startQuizAPI;
